import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type IconProps = {
  className?: string
  color?: string
  biIcon?: string
  dtIcon?: string
  faIcon?: string
  isLoading?: boolean
  position?: 'start' | 'end' | 'icon-only'
  float?: {top?: number; bottom?: number; left?: number; right?: number; rotate?: number; opacity?: number}
}

const Iconize: FC<IconProps> = ({className, color, biIcon, dtIcon, faIcon, isLoading, position, float}) => {
  return (
    <>
      {isLoading && (
        <i
          className={clsx(`fas fa-sync fa-spin ${color ? `text-${color}` : ''} ${className ?? ''}`, {
            'me-2': position == 'start',
            'ms-2': position == 'end',
          })}
        ></i>
      )}
      {!isLoading && (
        <>
          {biIcon != null && (
            <i
              className={clsx(`${biIcon} ${color ? `text-${color}` : ''} ${className ?? ''}`, {
                'me-2': position == 'start',
                'ms-2': position == 'end',
                'fa-fw': position != 'icon-only',
              })}
            ></i>
          )}
          {dtIcon != null && (
            <KTSVG
              path={`/media/icons/duotune/${dtIcon}.svg`}
              className={clsx(`svg-icon ${color ? `text-${color}` : ''} ${className ?? ''}`, {
                'me-2': position == 'start',
                'ms-2': position == 'end',
              })}
            />
          )}
          {faIcon != null && (
            <i
              className={clsx(`${faIcon} ${color ? `text-${color}` : ''} ${className ?? ''}`, {
                'me-2': position == 'start',
                'ms-2': position == 'end',
                'fa-fw': position != 'icon-only',
                'position-absolute': float != undefined,
              })}
              style={{
                top: float?.top,
                bottom: float?.bottom,
                left: float?.left,
                right: float?.right,
                transform: float?.rotate != undefined ? `rotate(${float.rotate}deg)` : undefined,
                opacity: float?.opacity,
              }}
            ></i>
          )}
        </>
      )}
    </>
  )
}

Iconize.defaultProps = {
  position: 'icon-only',
}

export default Iconize
